/**
 * App nativa VerSports Sensores (repo vrs-quest-sensores, vrs-docs 58) en la
 * Meta Horizon Store. Está en el canal Alpha privado: la ficha sólo se abre
 * para cuentas Meta invitadas a ese canal que aceptaron la invitación.
 */
export const SENSORES_APP_ID = '1327041000499897'
export const SENSORES_STORE_URL = `https://www.meta.com/experiences/${SENSORES_APP_ID}/`
export const SENSORES_CHANNELS_URL = `https://developers.meta.com/horizon/manage/applications/${SENSORES_APP_ID}/release-channels/`
